
import { Button } from '@/components/ui/button';
import { RefreshCw, Trash2 } from 'lucide-react';
import { Integration } from '@/types/integrations';
import { NuvemshopConnectionHandlers } from '../types';

interface NuvemshopErrorStateProps extends NuvemshopConnectionHandlers {
  integration: Integration;
}

export const NuvemshopErrorState = ({ 
  integration,
  handleConnectNuvemshop,
  handleDisconnect,
  isConnecting
}: NuvemshopErrorStateProps) => {
  return (
    <div className="text-center space-y-4 py-8">
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-yellow-700">
          {integration.status === 'error' ? 'Erro na Conexão' : 'Configurando...'}
        </h3>
        <p className="text-sm text-muted-foreground">
          {integration.status === 'error' 
            ? 'Houve um problema com a integração. Tente reconectar.'
            : 'A integração está sendo configurada.'
          }
        </p>
      </div>
      
      <div className="flex gap-2 justify-center">
        <Button 
          onClick={handleConnectNuvemshop}
          disabled={isConnecting}
          variant="outline"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          {isConnecting ? 'Reconectando...' : 'Tentar Novamente'}
        </Button>
        
        <Button 
          variant="destructive"
          onClick={handleDisconnect}
          size="sm"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Remover
        </Button>
      </div>
    </div>
  );
};
